module.exports = __webpack_public_path__ + "img/img_sub_brand_01_img.991d4b4f.png";